"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jun 29 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * PriceZoneConverter.
 *
 * @author JMe
 */


var PriceZoneConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceZoneConverter, _DataObjectConverter_);

  function PriceZoneConverter() {
    _classCallCheck(this, PriceZoneConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceZoneConverter).apply(this, arguments));
  }

  return PriceZoneConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceZoneConverter = PriceZoneConverter;